var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgLinkedin = function SvgLinkedin(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 16 16"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.926 0a1.926 1.926 0 1 0 0 3.851 1.926 1.926 0 0 0 0-3.851m10.118 5.112c-1.606 0-2.674.88-3.116 1.715h-.07v-1.47H5.707V16h3.29v-5.252c0-1.387.277-2.73 1.996-2.73 1.694 0 1.716 1.566 1.716 2.8V16H16v-5.847c0-2.862-.608-5.041-3.956-5.041M.315 5.357V16h3.326V5.357z"
  })));
};
export default SvgLinkedin;